<template>
  <div id="consulta d-flex flex-row flex-wrap justify-content-center">

    <b-modal ref="modalInstabilidade" @ok="confirmar" title="Atenção" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true">
      <p>
        Prezados,
      </p>
      <p>
        Os serviços que incidem em pagamento de emolumentos encontram-se bloqueados para manutenção do sistema e ajuste de valores. Retornaremos em breve.
      </p>
      <p>
        Qualquer dúvida, estamos à disposição!
      </p>
    </b-modal>

    <b-modal ref="modalLoading" size="xl" title="Carregando" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-footer="true">
      <p class="my-4">
        <template>
          <div class="d-flex justify-content-center mb-3">
            <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
          </div>
        </template>
      </p>
    </b-modal>
    <b-modal ref="modalPagamento" id="modalPagamento" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-header-close="true" size="lg">
      <template v-slot:modal-header="{ close }">
        <h5>Selecione a forma de pagamento</h5>
      </template>
      <template v-slot:default="{ hide }">
        <b-form-select id="input-4" v-model="formaPagamento" :options="formasPagamento" @change="alteraFPG"></b-form-select>
        <div v-if="formaPagamento.toString().includes('credit') == true" class="mt-4">
          <b-card bg-variant="light" title="Dados do cartão">
            <parcela-checkout
              :environment="ENVIRONMENT_EXPRESS"
              :clientKey="CLIENT_KEY_EXPRESS"
              :apiUrl="URL_EXPRESS"
              :sellerKey="SELLER_KEY_EXPRESS"
              successReturnUrl="https://success-url.com.br"
              errorReturnUrl="https://error-url.com.br"
            />
          </b-card>
        </div>
        <p class="mt-3">Caso o pagamento não seja realizado na data de vencimento, o pedido será automaticamente cancelado.</p>
        <br />
        <p>
          A opção de pagamento de certidão/cancelamento, seja por meio de PIX, cartão de crédito ou boleto não altera o prazo de entrega/efetivação, pois a transferência ao devido tabelionato, ocorre
          1 dia após ao efetivo pagamento.
        </p>
        <br />
        <p><b style="color: red;">*Após realizado o pagamento, os pedidos não poderão mais ser cancelados</b></p>
        <br>
        <p>O processamento dos pagamentos são realizados pela Parcela Express Servicos Digitais.</p>
      </template>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="lg" variant="danger" class="mr-auto" @click="respConfirm('n')">Cancelar</b-button>
        <b-button size="lg" variant="success" @click="respConfirm('s')" v-if="formaPagamento.toString().includes('credit') !== true">Aceitar</b-button>
      </template>
    </b-modal>
    <b-modal ref="ModalPagamentoCartao" title="Pagamento Recusado">
      <p>Pagamento recusado! Verifique os dados do cartão e tente novamente.</p>
    </b-modal>

    <b-modal ref="modalBoleto" :size="sizemodalboleto" scrollable title="Boleto" id="modalboleto">
      <div v-if="pdf">
        <div v-if="sizemodalboleto == 'lg'">
          <div class="col-12 text-center">
            <img src="~@/assets/imgs/logo.svg" class="w-50" />
            <br /><br /><br /><br />
            <h4>
              <b>Valor R$: {{ boletoSelecionado.vl_orcamento || Moeda }}</b>
            </h4>
            <br /><br />
          </div>
          <div class="offset-4 col-8 text-center qrcodePix">
            <b-embed type="iframe" aspect="1by1" :src="pdf" allowfullscreen v-if="pdf"></b-embed>
          </div>
          <div class="col-12 text-center">
            <h4><b>Faça a leitura do QR CODE e aguarde.</b></h4>
            <h4><b>Ou</b></h4>
            <b-card>
              <h5><b>LINK DE PAGAMENTO (PIX COPIA E COLA)</b></h5>
              <textarea class="textarea" ref="copiar" v-model="linkPIX" cols="80" rows="4"></textarea>
              <b-button variant="primary" @click="copiarLink()"> <font-awesome-icon icon="copy" /> &nbsp;&nbsp;&nbsp;&nbsp; Copiar link de pagamento </b-button>
            </b-card>
            <h4>
              <br /><br /><b>Consulta de pagamento em {{ secondcd }} segundos.</b>
            </h4>
          </div>
        </div>
        <div v-else>
          <b-embed type="iframe" aspect="1by1" :src="pdf" allowfullscreen v-if="pdf"></b-embed>
        </div>
      </div>
      <p v-else class="mensagemErro bold">{{ mensagemBolErro }}</p>
    </b-modal>

    <b-modal
      size="xl"
      scrollable
      title="Títulos com Anuência"
      id="modal-anuecia-cancelamento"
    >


      <div class="card" style="margin-bottom: 10px;" v-for="item in items"  v-bind:key="item.nm_chave">
        <div class="card-body">
          <h3 style="color: black;">{{ item.nome_cartorio | uppertitulo }}</h3>
          <p style="color: black;" >{{ item.endereco }} - {{ item.uf }} - {{ item.telefone | fone }}</p>

          <table class="table table-hover">
          <thead>
            <tr>
              <th scope="col">Devedor</th>
              <!-- <th scope="col">Protesto em</th> -->
              <th scope="col" style="text-align: right;">Valor Protestado</th>
              <th scope="col" style="text-align: right;">Valor p/ Cancelamento</th>
              <th scope="col" class="action-button">Ação</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="it in item.titulosf[0]" >
              <tr :key="it.nm_chave">
                <td>{{ it.doc_devedor | documento }}</td>
                <td style="text-align: right;">R$ {{ it.valorProtestado | moeda }}</td>
                <td style="text-align: right;">R$ {{ it.Valor | moeda }}</td>
                <td class="action-button">
                  <button
                    title="Cancelar Anuência"
                    type="button"
                    class="btn btn-danger btn-sm"
                    @click="cancProt(it.nm_chave, it.doc_devedor, item.uf, it.Valor, it.valorProtestado, it.codigo_abrancia, it.numero)"
                  >
                    <!-- @click="cancProt_instabilidade()" -->
                    Cancelar protesto
                  </button>
                </td>
              </tr>

              <tr v-if="it.vl_servico_complementar > 0" :key="it.nm_chave + '_alerta'">
                <td colspan="4" class="p-0">
                  <b-alert
                    variant="warning"
                    class="text-center shadow-sm alerta-anuencia"
                    show
                  >
                    <span  style="font-size: 14px;">
                      (Valor dos Emolumentos: R$ {{ it.vl_custas_cartorio }} | Preço da utilização da plataforma: R$ {{ it.vl_servico_complementar }})
                      <span :id="'pop_vlr_ineo_' + it.nm_chave">
                        <font-awesome-icon
                          icon="info"
                          mask="circle"
                          size="1x"
                          color="blue"
                        />
                      </span>
                      <b-popover
                        :target="'pop_vlr_ineo_' + it.nm_chave"
                        triggers="hover"
                        placement="top"
                      >
                        <p>Referente a 5% dos emolumentos.</p>
                      </b-popover>
                    </span>
                  </b-alert>
                </td>
              </tr>
            </template>
          </tbody>
        </table>

        </div>
      </div>
      <br>
    </b-modal>

    <b-modal ref="modalErro" title="Atenção" @ok="confirmar" v-if=" msgValida != null ">{{ msgValida }}</b-modal>
    <b-modal ref="modalErro" title="Atenção" @ok="confirmar" v-else>Não foram localizados títulos protestados com autorização de cancelamento pelo o documento pesquisa. Para realizar a consulta gratuita de protesto,<b-button variant="link" @click="$router.push({ name: 'home' })">clique aqui</b-button></b-modal>
    <a style="display:block" :id="'download_boleto'" :download="'download_boleto'" />
    <div id="wrapper-spinner" v-if="exibir">
      <BeatLoader color="var(--main-azul)" />
    </div>
  </div>
</template>

<script>
import BeatLoader from "vue-spinner/src/BeatLoader.vue";
import API from '../../services/api'
import axios from "axios"
import '@parcelaexpress/checkout-component-js';

export default {
  props:['itemsp', 'servicoComplementar'],
  components: {
    BeatLoader,
  },
  data() {
    return {
      sitekey: process.env.VUE_APP_sitekeyRecaptcha,
      cpf_cnpj: "",
      msgValida:null,
      logged: false,
      documento: "",
      items: [],
      tok: "",
      exibir: false,
      formaPagamento: 0,
      boletoSelecionado:{},
      servico_complementar: {},
      formasPagamento: [
        { text: "Selecione uma opção de pagamento", value: 0 },
        { text: "BOLETO - Parcela Express (Tarifa Bancária - R$ 0,87)", value: 2 }, //comentado até virada da tabela de custas
        { text: "PIX - Parcela Express (Gratuito)", value: 3 },
      ],
      secondcd: 30,
      pdf: null,
      sizemodalboleto: "xl",
      linkPIX: "",
      mensagemBolErro: "",
    };
  },
  mounted() {
    this.items = this.$props.itemsp;
    
    this.$root.isLogged().then(() => {
        this.logged = true;
      }).catch(() => {
        this.logged = false;
      })
  
  },
  filters: {
    moeda: function (value) {
      if (!value && value !== 0) return ''; // previne erro em null/undefined
      var v = value.toString().replace(/\D/g, '');
      v = (v/100).toFixed(2) + ''
      v = v.replace(".", ",")
      v = v.replace(/(\d)(\d{3})(\d{3}),/g, "$1.$2.$3,")
      v = v.replace(/(\d)(\d{3}),/g, "$1.$2,")
      return v
    },
    uppertitulo: function (value){
      if (!value) return ''
      value = value.toString()
      var vall = value.toLowerCase()
      return vall.charAt(0).toUpperCase() + vall.slice(1)
    },
    fone: function (value){
      if (value != undefined) {
        var d = ''
        if(value.length > 10){
          d = value
          d = d.replace(/\D/g, "")
          d = d.replace(/^(\d\d)(\d)/g, "($1) $2")
          d = d.replace(/(\d{5})(\d)/, "$1-$2")
          return d
        }else{
          d = value
          d = d.replace(/\D/g, "")
          d = d.replace(/^(\d\d)(\d)/g, "($1) $2")
          d = d.replace(/(\d{4})(\d)/, "$1-$2")
          return d
        }
      }
    },
    documento: function (value) {
      if (value == null) {
          return '';
      } else {
          let v = value;
          //Remove tudo o que não é dígito
          v = v.replace(/\D/g, "");
          if (v.length < 14) { //CPF
              v = v.replace(/(\d{3})(\d)/, "$1.$2");
              v = v.replace(/(\d{3})(\d)/, "$1.$2");
              v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
          } else { //CNPJ
              v = v.replace(/^(\d{2})(\d)/, "$1.$2");
              v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
              v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
              v = v.replace(/(\d{4})(\d)/, "$1-$2");
          }
          return v;
      }
    }
  },
  methods: {
    //desableRC: function(e) {
    confirmar(){
      document.getElementById("cpf_cnpj").focus()
    },
    solicitar(nm_chave, cpfCnpj, vl_protestado) {
      this.cpf_cnpj= cpfCnpj;
      if(nm_chave) {
        if(this.validar()){
          //  iniciando solicitação -> login / cadastro
          //  armazena a chave
          localStorage.setItem("nm_chave", nm_chave)
          localStorage.setItem("cpfCnpj", cpfCnpj)
          localStorage.setItem("vl_protestado", vl_protestado)
          //  redireciona para login
          if(this.logged)this.$router.push({ name: 'painel'})
          else this.$router.push({ name: 'login', params: { tipo_login: 'solicitarCancelamentoAnuencia' } })
        } else {
          alert('informe o cpf')
        }
      }
    },
    validar() {
      let len = this.cpf_cnpj.length;
      //let doc = this.cpf_cnpj
      return len == 11 || len == 14 ? true : false;
      //return len == 11 ? Serv.validarCPF(doc) : len == 14 ? Serv.validarCNPJ(doc) : false
    },
    verificaInputConsulta() {
      if (!this.cpf_cnpj) this.placeholderInputConsulta(true);
    },
    inputConsultaFocus() {
      document.getElementById("cpf_cnpj").focus();
    },
     moeda: function (value) {
      var v = value.replace(/\D/g,'')
      v = (v/100).toFixed(2) + ''
      v = v.replace(".", ",")
      v = v.replace(/(\d)(\d{3})(\d{3}),/g, "$1.$2.$3,")
      v = v.replace(/(\d)(\d{3}),/g, "$1.$2,")
      return v
    },
    respConfirm(resp) {
      if (resp == "s" && this.formaPagamento != 0) {
        const token = localStorage.getItem("jwtToken");
        const dadosParaEnvio = { filtro: this.boletoSelecionado, formaPagamento: this.formaPagamento };
        this.$refs["modalLoading"].show();

        API.post(`certidao/gerarBoleto`, { token: token, dados: dadosParaEnvio })
          .then((res) => {
            if (res.data.situacao == 1) {
              // this.get_certidoes();

              if (this.formaPagamento == 2) {
                // console.log('download_boleto_' + this.boletoSelecionado.cd_pedido)
                this.$refs["modalLoading"].hide();
                let dwnldAnexo = document.getElementById("download_boleto");
                dwnldAnexo.href = res.data.urlBoleto;
                //setTimeout(function(){
                dwnldAnexo.click();
                this.$refs["modalPagamento"].hide();
              } else if (this.formaPagamento == 3) {
                // console.log('download_boleto_' + this.boletoSelecionado.cd_pedido)
                this.linkPIX = res.data.urlBoleto;
                var Quickchart = 'https://quickchart.io/qr?size=300&text=';
                this.pdf = Quickchart + encodeURI(this.linkPIX);
                // GoogleCharts QR Code - DEPRECATED
                // var GoogleCharts = "https://chart.googleapis.com/chart?chs=300x300&cht=qr&chl=";
                // this.pdf = GoogleCharts + this.linkPIX;

                this.sizemodalboleto = "lg";
                this.startCountDown(30);
                let countInterval2 = setInterval(() => {
                  this.startCountDown(30);
                  this.verificaPagamento(res.data.idBoleto);
                }, 30000);
                this.$root.$on("bv::modal::hidden", (bvEvent, modalId) => {
                  if (modalId == "modalboleto" && bvEvent.type == "hidden") clearInterval(countInterval2);
                });

                this.$refs["modalLoading"].hide();
                this.$refs["modalPagamento"].hide();
                this.$refs["modalBoleto"].show();
              }
            } else {
              this.mensagemBolErro = res.data.mensagem;
              this.$refs["modalLoading"].hide();
              this.$refs["modalBoleto"].show();
            }
            //let resJson = JSON.parse(res.data['enviada']);
            //console.log(resJson);
          })
          .catch((erro) => {
            alert('Falha na operação')
            console.log("post não enviado", erro);
          });
      } else if (resp == "n") {
        this.$refs["modalPagamento"].hide();
      }else if (this.formaPagamento == 0) {
        alert('por favor, selecione uma forma de pagamento')
      }
    },
    startCountDown(duration) {
      let secondsRemaining = duration,
        sec = 0,
        countInterval = setInterval(() => {
          sec = parseInt(secondsRemaining % 60);
          this.secondcd = sec;
          secondsRemaining = secondsRemaining - 1;
          if (secondsRemaining < 0) clearInterval(countInterval);
        }, 1000);
    },
    copiarLink() {
      var copyTextarea = this.$refs.copiar;

      copyTextarea.select();

      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "Texto copiado!" : "Texto não copiado !";
        alert(msg);
      } catch (err) {
        alert("Opa, Não conseguimos copiar o texto, é possivel que o seu navegador não tenha suporte, tente usar Crtl+C.");
      }
    },
    gerarBoleto(vl_cancelamento, nm_chave, documento, vl_protestado, cd_ibge){
      
      let vl_cancelamento_total = this.calculaValorCancelamento(vl_cancelamento);
      //console.log(dadosTitulo);
      const token = localStorage.getItem("jwtToken");
      // this.$bvModal.show('modal-conf');
      this.boletoSelecionado.token = token;
      this.boletoSelecionado.vl_orcServ = vl_cancelamento;
      this.boletoSelecionado.vl_orcamento = vl_cancelamento;
      this.boletoSelecionado.nm_chave = nm_chave;
      this.boletoSelecionado.cpfCnpj = documento;
      this.boletoSelecionado.vl_protestado = vl_protestado;
      this.boletoSelecionado.cd_ibge = cd_ibge;
      this.boletoSelecionado.consulta = 1;
      this.boletoSelecionado.vl_servico_complementar = this.getValorServicoComplementar(vl_cancelamento);
     

      API.post(`certidao/travas_pedido`, this.boletoSelecionado).then( (res) => {
        if(res.data.situacao)
        {
          this.simulacaoPagamentos(vl_cancelamento)
          this.linkPIX = '';
          this.formaPagamento = 0;
          this.$refs['modalPagamento'].show();
        }
        else 
        {
          this.msgValida = res.data.mensagem
          this.$refs['modalErro'].show();
        }
        
      })
      
      //localStorage.setItem('idPedido');
      //this.bolSel = pedidoid;
    },
    cancProt_instabilidade() {
      this.$refs['modalInstabilidade'].show();
    },
    async cancProt(nm_chave, documento, uf, vl_custas, vl_protestado, cd_ibge) {
      if (uf != "SP") {
        //enviar o usuario para efetuar o login
        if (!localStorage.getItem("jwtToken")) {
          this.$router.push({ name: "login", params: { tipo_login: "" } });
        }
        const valorCustas = parseFloat(vl_custas.replace("R$ ", "").replace(",", "."));
        const valorProtesto = parseFloat(vl_custas.replace("R$ ", "").replace(",", "."));
        this.gerarBoleto(valorCustas, nm_chave, documento, valorProtesto, cd_ibge)
        
        // this.$refs["modalLoading"].show();

        const token = localStorage.getItem("jwtToken");
        document.getElementById(nm_chave).innerHTML =
          "<div class='alert alert-warning' role='alert' style='text-align:center'>Processando ....<div class='spinner-grow' role='status'><span class='sr-only'></span></div></div>";

        // API.post(`consulta/gerarBoleto?token=${token}`, {
        //   nm_chave: nm_chave,
        //   cpfCnpj: documento,
        //   uf: uf,
        //   vl_custas: vl_custas,
        //   vl_protestado: vl_protestado,
        //   cd_ibge: cd_ibge,
        //   nr_cartorio: nr_cartorio,
        // }).then((res) => {
        //   if (res.data.tempedido) {
        //     this.nm_chave = res.data.nm_chave;
        //     this.linha = index;
        //     this.tempedido = true;
        //     document.getElementById(this.nm_chave + this.linha).style.display = "none";
        //     this.$refs["modalBoleto"].show();
        //   } else {
        //     if (res.data.mensagem == "Comarca Bloqueada") {
        //       this.msg_retorno = res.data.mensagem;
        //       this.$refs["modalBoleto"].show();
        //     }
        //   }
        //   this.$refs["modalLoading"].hide();
        //   this.msg_retorno = res.data.mensagem;
        //   this.ds_endereco_boleto = res.data.ds_endereco_boleto;
        // });
        //        API.get(`consulta/dadosanuencia/${nm_chave}/${token}`).then((res) => {
        //          })
      } //diferente sp
      else {
        window.open("https://protestosp.com.br/Cancelamentos/Simples", "_blank");
      }
    },
    async simulacaoPagamentos(vlr_simulacao){
      console.log(vlr_simulacao)
      let valor_simulado = parseFloat(vlr_simulacao).toFixed(2).replace('.','') / 1
      let resSimulacao = await axios.get(`${process.env.VUE_APP_URL_EXPRESS}/v1/simulation/sellers/${process.env.VUE_APP_SELLER_KEY_EXPRESS}?amount_cents=${valor_simulado}`);
      // console.log(resSimulacao.data)
      // resSimulacao = JSON.parse(resSimulacao.data);
      // console.log(resSimulacao.installment_amount_cents)
      let formasPagamentoSimulacao = resSimulacao.data.filter( d => d.type == 'credit')
      let self = this
      this.formasPagamentoExpress = formasPagamentoSimulacao
      formasPagamentoSimulacao.forEach( (value) => {
        self.formasPagamento.push({html: '<b> Cartão de Crédito - Parcela Express  ' + value.installment  + ' x ' + this.formataReais(value.installment_amount_cents) +'</b> ( Tarifa Bancária - ' + value.cet + '% )', 'value': value.code })
      })
    },
    async alteraFPG(){
      this.percent_value = null
      // let valor_calculado = this.calcula_valor_pagamento();
      let self = this
      let retornoIP = await axios.get(`https://api.ipify.org/?format=json`)
      
      const token = localStorage.getItem('jwtToken')
      let costumerBillinAdrres =  await API.get(`usuario/logado/endereco?token=${token}`)
      costumerBillinAdrres = costumerBillinAdrres.data
      
     
      setTimeout(function () {
        const web_component = document.querySelector('parcela-checkout');
        let dadosFormaPagamento = self.formasPagamentoExpress.filter( d => d.code == self.formaPagamento)[0]
        let amount_cents = dadosFormaPagamento != undefined ? parseInt(dadosFormaPagamento.total_amount_cents) : '';
        // console.log(self.boletoSelecionado)

        if(self.formaPagamento.toString().includes("credit") == true)
        {
          API.post(`cancelamento/gerarPedido`, self.boletoSelecionado).then( (res) => {
            self.boletoSelecionado.cd_pedido = res.data.cd_pedido
            let description = 'Pagamento Pedido de ' + (self.boletoSelecionado.cd_produto == 3 ? 'Cancelamento Protesto' : 'Certidao ') +  'N: ' + res.data.cd_pedido;

          
            web_component.customerData = {
             amount_cents: amount_cents,
             description: description,
             form_payment: "credit",
             installment_plan: {
               number_installments: dadosFormaPagamento.installment,
             },
             customer: {
               email: localStorage.getItem('usrEmail'),
               ip: retornoIP.data.ip,
               first_name: localStorage.getItem('usrName'),
               last_name: " ",
               document: localStorage.getItem('usrCpf'),
               billing_address: {
                 city: costumerBillinAdrres.cidade || 'São Paulo',
                 country: costumerBillinAdrres.pais || 'Brasil',
                 house_number_or_name: costumerBillinAdrres.numero || '377',
                 postal_code: costumerBillinAdrres.cep ? costumerBillinAdrres.cep.replace('-','') : '',
                 state: costumerBillinAdrres.estado || 'SP',
                 street: costumerBillinAdrres.rua || 'Rua Líbero Badaró',
               },
             },
             extract_identification:'IEPTB-BR',
             pre_capture: false,
             has_split_rules: false,
             confirmation_required: false,
           };
         
           web_component.onChange = () => 
             {
               // console.log(state);
             }
           
             web_component.beforeSubmit  = () => self.$refs['modalLoading'].show();
           
             web_component.onSubmit = (state) => {
              self.$refs['modalLoading'].show();
              if(state.resultCode == 'Authorised')
              {
                self.atualizaPagamento(state.sale_id);
              }
              else
              {
                self.$refs['modalLoading'].hide();
                self.$refs['ModalPagamentoCartao'].show();
              }
            };
        })
        }
        },1)
    },
    formataReais(number){
      number = parseFloat((number/100)).toFixed(2);
      return new Intl.NumberFormat('pt-BR', {style: 'currency',currency: 'BRL', minimumFractionDigits: 2}).format(number);
    },
    calculaValorCancelamento(vl_custas){
      if (typeof vl_custas === 'string')vl_custas = vl_custas.replace(/R\$\s*/g, '');
      let valorCancelamento = parseFloat(vl_custas);

      let valorServico = this.getValorServicoComplementar(vl_custas);

      if (valorServico === 0 || valorCancelamento === 0) return valorCancelamento;
      
      return Math.round((valorCancelamento + valorServico) * 100) / 100;
    },
    getValorServicoComplementar(vl_custas){
      if (typeof vl_custas === 'string')vl_custas = vl_custas.replace(/R\$\s*/g, '');
      let valorCancelamento = parseFloat(vl_custas);

      let servico = this.servicoComplementar;
      if (!servico) return 0;

      let valorServico = parseFloat(servico.vl_servico) || 0;
      if (valorServico === 0) return 0;
      
      if (servico.ic_percentual) {
        let percentual = (valorCancelamento * valorServico) / 100;
        return Math.round(percentual * 100) / 100;
      } else {
        return Math.round(valorServico * 100) / 100;
      }
    }
  }
};
</script>

<style scoped>
h1 {
  font-size: 40px;
}
h1,
p,
p b {
  color: #fff;
}
p {
  font-size: 17px;
}
p > b {
  margin-right: 15px;
}
#wrapper-spinner {
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: calc(100% - 80px);
}
#wrapper-spinner .v-spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -10px 0px 0px -20px;
}
#consulta-form {
  font-family: "Kanit", sans-serif !important;
}
#banner1 {
  background-image: url("~@/assets/imgs/anuenciaCons.jpg");
  background-repeat: no-repeat;
  max-width:100%;
	height:auto;
  margin-top: -51px;
}
.containerB {
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  border: 1px solid #ccc;
  height: 100%;
  position: absolute;
  /* margin-top: 579px; */
  width: 100%;
}
.container {
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  height: 100%;
  padding-right: 0px;
  padding-left: 0px;
  position: absolute;
}
.nowrap {
  flex-wrap: nowrap;
}
.column-nowrap {
  flex-flow: column nowrap;
}
#wrapper-input {
  background-color: rgba(255, 255, 255, 0.3);
  border: 2px solid rgb(255, 255, 255) !important;
  width: 52%;
  height: 28%;
  margin-left: 25%;
  position: absolute;
  z-index: 10;
}
#cpf_ou_cnpj {
  position: absolute;
  left: 15px;
  font-size: 19px;
  letter-spacing: 0.25px;
  color: #fff;
  opacity: 1;
  transition: all 0.8s ease-out;
  font-size: 30px;
  bottom: -8px;
}
#cpf_ou_cnpj.hide {
  bottom: 0px;
  opacity: 0;
}
#cpf_cnpj {
  width: 100%;
  height: 210%;
  background: none;
  color: #fff;
  border: none;
 font-family: "Kanit", sans-serif !important;
  font-size: 32px;
  letter-spacing: 2px;
}
#bt-consultar {
  cursor: pointer;
  float: right;
  width: 45%;
  height: 84%;
  color: #fff;
  background-color: #de8800;
 font-family: "Kanit", sans-serif !important;
  font-size: 30px;
  margin-right: 8px;
  margin-top: 4px;
}
#wrapper-cpf_cnpj {
  padding: 10px 0px 10px 10px;
  position: absolute;
  width: 54%;
  height: 70% !important;
}
.itemB {
  flex: 1;
  text-align: center;
  font-size: 1.5em;
}
.item {
  /* O flex: 1; é necessário para que cada item se expanda ocupando o tamanho máximo do container. */
  flex: 1;
  text-align: center;
  font-size: 1.5em;
}
.space-around {
  justify-content: space-around;
}
.column {
  min-height: 100%;
  flex-direction: column;
}
.flex {
  flex: 1;
}
.itemB1 {
  background-color: rgba(20, 96, 118, 0.75);
}
.itemB2 {
  background-color: rgba(20, 96, 118, 0.75);
}
.itemB3 {
  background-color: #146076;
}
.itemConsulta {
  background-color: rgba(20, 96, 118, 0.75);
}
#rodape {
  background-color: #185684;
  width: 100%;
  height: 229px;
  position: absolute;
  z-index: 10;
  bottom: 0;
  margin-bottom: 0;
}
#rodapeV {
  background-color: #185684;
  width: 100%;
  height: 227px;
  position: absolute;
  z-index: 10;
  bottom: 0;
  margin-bottom: 0%;
}
.text-amarelo {
  color: #ffa20e;
}
.letraInstProt {
  font-size: 28px;
}
.letraAtencao {
  font-size: 38px;
}
@media (min-width: 320px) and (max-width: 765px) {
  h1 {
    font-size: 22px;
}
  #banner1 {
    background-image: url("~@/assets/imgs/anuenciaConsCell.jpg");
    background-repeat: no-repeat;
    height: 546px;
    margin-top: 80px;
    margin-left: -119px;
    max-width: 133%;

}
  #consulta {
    width: 100%;
    background-image: url("~@/assets/imgs/7.jpg") !important;
    background-size: cover;
    background-attachment: scroll;
    height: 100vh;
    overflow: hidden;
    top: 0;
    left: 0;
    /* Preserve aspect ratio */
    min-width: 100%;
    min-height: 100%;
    position: fixed;
}
  #rodapeV {
    height: 234px;
}
  #bt-consultar {
    width: 100%;
    height: 50%;
    font-size: 16px;
    margin-right: 0%;
    margin-top: 37px;
}
  #cpf_ou_cnpj {
    font-size: 19px;
}
  .letraInstProt {
    font-size: 18px;
}
  .letraAtencao {
    font-size: 22px;
}
  #cpf_ou_cnpj {
    font-size: 18px;
    bottom: 20px;
}
#wrapper-input {
    width: 90% !important;
    height: 33% !important;
    margin-left: 5% !important;
}
#cpf_cnpj {
    font-size: 17px;
    margin-top: -14px;
    height: 100%;
}
#wrapper-cpf_cnpj {
    width: 100%;
    height: 70% !important;
  }
}
@media (min-width: 766px) and (max-width: 900px) {
#wrapper-input {
    height: 22%;
    margin-left: 7%;
    width: 86%;
}
#consulta {
    width: 100%;
    background-image: url("~@/assets/imgs/7.jpg") !important;
    background-size: cover;
    background-attachment: scroll;
    height: 100vh;
    overflow: hidden;
    top: 0;
    left: 0;
    /* Preserve aspect ratio */
    min-width: 100%;
    min-height: 100%;
}
#banner1 {
    background-image: url("~@/assets/imgs/anuenciaCons4.jpg");
    max-width: 100%;
    height: auto;
    width: 100% !important;
    }
}
@media (min-width: 1200px) and (max-width: 1600px) {
#banner1 {
    background-image: url("~@/assets/imgs/anuenciaCons3.jpg");
    height: 966px;
    margin-top: -29px;
}
#wrapper-input {
    border: 2px solid rgb(255, 255, 255) !important;
    width: 71%;
    height: 28% !important;
    margin-left: 15%;
  }
}
.vtm {
    border: none;
    outline-offset: 0px;
    outline: 0px auto -webkit-focus-ring-color;
}

.table thead th{padding: 0.75rem !important;}
.table td.action-button{width: 191px;}
.table thead th,
.table td{
  font: normal normal normal 15px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  height: 48px;
  color: #597EB5;
  vertical-align: middle;
}
.table button{
  
  width: 167px;
  height: 49px;
  background: #F2F6FE 0% 0% no-repeat padding-box;
  border: 3px solid #4780F1;
  border-radius: 5px;
  color: #4780F1;
  text-align: center;
  font: normal normal bold 15px/30px 'Kanit', sans-serif;
  letter-spacing: 0px;
}
.table button:active,
.table button:focus,
.table button:hover{
  outline: none !important;
  box-shadow: none !important;
  background-color: #4780F1 !important;
  border-color: #4780F1 !important;
  color: white;
}
 p {
  font: normal normal normal 15px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color:#000;
  margin-bottom: 0;
}
.alerta-anuencia{
  max-height: 99px;
  padding: 15px 17px;
  border-radius: 5px;
  font: normal normal bold 15px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  text-align:start !important;
}

</style>
